<template>
	<v-dialog
		v-if="show"
		v-model="show"
		max-width="800px"
		persistent
	>
		<v-card>
			<v-card-title class="py-3" style="justify-content: center;">
				<h5 class="headline">Edit Publication</h5>
			</v-card-title>
			<v-divider />
			<v-card-text>
				<v-layout
					v-if="$store.get('superUser')"
					wrap
					class="superUser"
				>
					<v-flex>
						<v-autocomplete
							label="Publication"
							v-model="article.publicationId"
							:items="publications"
							item-text="v"
							item-value="k"
							clearable
							:loading="publicationsLoading"
							:disabled="publicationsLoading"
							hide-no-data
							@input.native="searchPublications"
						/>
					</v-flex>
				</v-layout>
				<ImageUpload :item="publication" />
			</v-card-text>
			<v-divider />
			<v-card-actions class="py-3">
				<v-layout justify-center>
					<v-btn
						color="error"
						@click="$emit('close')"
					>
						Close
					</v-btn>
				</v-layout>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { sync } from 'vuex-pathify';
import axios from '@/util/axios';

export default {
	components: {
		ImageUpload: () => import('@/components/ImageUpload'),
	},
	props: {
		show: { type: Boolean, default: false },
		article: { type: Object, default: null },
	},
	data() {
		return {
			publications: [],
			publicationsLoading: false,
		}
	},
	computed: {

		publication() {
			return this.article.publicationModel;
		},

	},
	watch: {
		// Add currently selected publication to the array
		show(val) {
			if (val) {
				const inArray = this.publications.find(p => p.id === this.publication.id);
				if (!inArray) {
					this.publications.push({
						k: this.publication.id,
						v: this.publication.name,
					});
				}
			}
		},
	},
	methods: {
		searchPublications(e) {
			// Read the searched text
			const text = e.srcElement.value;
			// Clear items, so v-autocomplete won't search new value from previous results
			this.publications = [];
			// Clear previous timeout
			if (this.timeout) {
				clearTimeout(this.timeout);
			}

			this.timeout = setTimeout(() => {

				if (text.length < 3) {
					return;
				}
				this.publicationsLoading = true;
				axios.get(`/publications/all-names?q=${text}`).then(r => {
					this.publications = r.data;
				}).catch(e => {
					this.publications = [];
					dump(e);
				}).finally(() => {
					this.publicationsLoading = false;
				});
			}, 1000);
		},
	},
	destroyed() {
		clearInterval(this.timeout);
	},
}
</script>
